<template>
  <div>
    <!--<h1>New EXCMAgreementSla</h1>-->
    <b-row>
      <b-col>
        <div v-if="isLoading" class="alert alert-info" role="status">{{$t('alerts.loading')}}...</div>
        <div v-if="error" class="alert alert-danger" role="alert">
          <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <EXCMAgreementSlaForm
                :type="1"
                :handle-submit="onSendForm"
                :handle-update-field="updateField"
                :values="item"
                :errors="violations" />
      </b-col>
    </b-row>
    <!--<b-row>-->
      <!--<b-col>-->
        <!--<router-link-->
                <!--:to="{ name: 'EXCMAgreementSlaList' }"-->
                <!--class="btn btn-default">Back to list</router-link>-->
      <!--</b-col>-->
    <!--</b-row>-->
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMAgreementSlaForm from './Form'

const { mapGetters, mapActions } = createNamespacedHelpers('excmagreementsla/create')

export default {
  components: {
    EXCMAgreementSlaForm
  },

  props: {
    agreementIRI: {
      type: Text,
      default: null
    }
  },

  data () {
    return {
      routeName: '',
      item: {}
    }
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }

      if (this.routeName === 'EXCMAgreementShow') {
        this.$Swal({
          title: this.$t('notifications.created'),
          type: 'success'
        })
        this.$store.state.modals.excmagreementsla.create.created = 1
        this.$store.state.modals.excmagreementsla.create.close = 1
      } else {
        this.$router.push({ name: 'EXCMAgreementSlaUpdate', params: { id: created['@id'] } })
      }
    }
  },

  created () {
    this.routeName = this.$route.name
    if (this.agreementIRI) {
      this.item.agreement = this.agreementIRI
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      this.create(this.item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
